import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import EvaluationTab from './EvaluationTab';
import AspectsTab from './AspectsTab';

export default function ExpandedContainer({ inspectionID }) {
  const [activeTab, setActiveTab] = useState('evaluation');

  return (
    <Tabs defaultActiveKey={activeTab} onSelect={(v) => setActiveTab(v)}>
      <Tab
        eventKey="evaluation"
        title="Verificaciones"
        className="p-3 border-top-0 bg-white"
      >
        {activeTab === 'evaluation' && (
          <EvaluationTab inspectionID={inspectionID} />
        )}
      </Tab>
      <Tab
        eventKey="aspects"
        title="Aspectos"
        className="p-3 border-top-0 bg-white"
      >
        {activeTab === 'aspects' && <AspectsTab inspectionID={inspectionID} />}
      </Tab>
    </Tabs>
  );
}
